import React, { useState, useEffect, useCallback } from "react";
import "./Ranking.scss";
import Tooltip from "../../commons/tooltip/Tooltip";
import ColumnChart from "../../commons/column-chart/ColumnChart";

const SectionRanking = ({ afps, funds, periods, columChartProps, information, dateRange }) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  const [currentFund, setCurrentFund] = useState("");
  const [currentPeriod, setCurrentPeriod] = useState("");
  const [currentDateRange, setCurrentDateRange] = useState("");

  useEffect(() => {
    if (!funds || !periods || !dateRange) return;

    const activeFund = funds.list.find((item) => item.active === true);
    const currentFund = funds.list.length > 0 ? activeFund?.id : "";

    const activePeriod = periods.list.find((item) => item.active === true);
    const currentPeriod = periods.list.length > 0 ? activePeriod?.period_id : "";

    const currentDateRange = dateRange.length > 0 ? dateRange[0].text : "";
    setCurrentFund(currentFund);
    setCurrentPeriod(currentPeriod);
    setCurrentDateRange(currentDateRange);
  }, [funds, periods, dateRange]);

  const toggleTooltip = useCallback((event) => {
    event.preventDefault();
    setOpenTooltip((prev) => !prev);
  }, []);

  const onChangeValue = (name, value) => {
    let range;
    if (name === "currentFund") {
      const found = dateRange.filter((item) => item.fund_id === value);
      range = found.find((item) => item.period_id === currentPeriod);
    } else {
      const period = dateRange.filter((item) => item.period_id === value);
      range = period.find((item) => item.fund_id === currentFund);
    }
    if (name === "currentFund") {
      setCurrentFund(value);
    } else {
      setCurrentPeriod(value);
    }
    setCurrentDateRange(range?.text || "");
  };

  const btnPeriodClass = (id) => {
    return `btn btn-year ${currentPeriod === id ? "btn-year--active" : ""}`;
  };

  const btnfundsClass = (id) => {
    return `hbi-item-fondo ${currentFund === id ? "hbi-item-fondo--active" : ""}`;
  };

  const dataFilter = {
    currentFund,
    currentPeriod,
    afps,
    data: columChartProps,
  };

  const tagBtnInformation = () => {
    let title = information.btnInformation.title;
    title = title.split("#");
    return (
      <a
        href={"#!"}
        className={`btn btn-legal-information`}
        onClick={toggleTooltip}
      >
        {title[0]} <strong>{information.btnInformation.reference.name}</strong>
      </a>
    );
  };

  const getOnlyDay = () => {
    return currentDateRange;
  };

  const tagSplitStrong = () => {
    let description = information.btnInformation.reference.popPup.description;
    let subString = description.split("#");
    let cambioAnios = subString[2].split("AFP Abril 2019 / Abril 2014");
    return (
      <div>
        <strong>{subString[1]}</strong> {cambioAnios[0]} {getOnlyDay()} {cambioAnios[1]}
        <strong>{subString[3]}</strong>
      </div>
    );
  };

  const paragraph = () => {
    const text = information.subTitle;
    let subString = text.split("#");
    return {
      firtParagraph: subString[0],
      secondParagraph: subString[1],
    };
  };

  return (
    <section id={"ranking-de-rentabilidad"} className={`general-ranking grafico2`}>
      <div className={`container hbi-section-ranking`}>
        <div className={`text-center`}>
          <h2 className={`text-title`}>{information.title}</h2>
          <p className={`hbi-text-ranking`}>
            {paragraph().firtParagraph} <span> / <strong>{currentDateRange}</strong> </span>
          </p>
          <p>{paragraph().secondParagraph}</p>
        </div>
        <div className={`hbi-content-years`}>
          <ul className={`hbi-years`}>
            {periods.list.map((item) => (
              <li key={item.period_id} className={`hbi-item-year`}>
                <button
                  className={btnPeriodClass(item.period_id)}
                  onClick={() => onChangeValue("currentPeriod", item.period_id)}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className={`hbi-content-tabs-fondo`}>
          <ul className={`hbi-tabs-fondo`}>
            {funds.list.map((item) => (
              <li
                key={item.id}
                className={btnfundsClass(item.id)}
                onClick={() => onChangeValue("currentFund", item.id)}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
        <ColumnChart {...dataFilter} />
        <div className={`hbi-content-position`}>
          <ul className={`hbi-position`}>
            <li className={`hbi-item-position`}>1er</li>
            <li className={`hbi-item-position`}>2do</li>
            <li className={`hbi-item-position`}>3er</li>
            <li className={`hbi-item-position`}>4to</li>
            <li className={`hbi-item-position`}>5to</li>
          </ul>
        </div>
      </div>
      <div className={`hbi-content-legal hbi-reference-topltip d-none`}>
        {tagBtnInformation()}
        {openTooltip && <Tooltip {...information.btnInformation.reference.popPup} />}
      </div>
      <div className={`container`}>
        <div className={`container tooltip-reference`}>
          <div>{tagSplitStrong()}</div>
        </div>
      </div>
    </section>
  );
};

export default SectionRanking;